export const debug = (...arguments_: unknown[]): void => {
  console.debug('[Auth]', ...arguments_);
};
